var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"tag":"a","to":'/'}},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/icons/onestepcloud.svg")}})]),_c('div',{staticClass:"container"},[_c('Loader')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }